import moment from 'moment';
import { AnyAction, Reducer } from 'redux';

import {
  GET_HEATMAP_DATA,
  GET_HEATMAP_ERROR,
  GET_SATURATION,
  GET_SATURATION_ERROR,
  GET_SATURATION_RULES,
  SET_SATURATION,
  SET_SELECTED_SATURATION,
  TOGGLE_HEATMAP,
  TOGGLE_SATURATION,
  TOGGLE_SATURATION_AUTOREFRESH,
  SET_SELECTED_HEATSATURATION
} from './saturation.types';
import { SaturationData } from 'models/saturation-data';
import { HeatmapGeo, Heatmap } from 'models/heatmap';
import { SaturationRule } from 'models/saturation-rules';
import { AutoRefreshModel } from 'models/autorefresh';
import { Saturation } from 'models/saturation';

export interface SaturationState {
  saturationVisible: boolean;
  heatmapVisible: boolean;
  mapSaturation: Saturation[];
  loadingSaturation: boolean;
  interval: any;
  selectedSaturation?: SaturationData;
  selectedHeatSaturation?: HeatmapGeo;
  saturationRules: SaturationRule[];
  loadingSaturationRules: boolean;
  heatmap?: Heatmap;
  loadingHeatmap: boolean;
  autoRefresh: {
    saturation: AutoRefreshModel;
  };
}

const initialState: SaturationState = {
  saturationVisible: false,
  heatmapVisible: false,
  mapSaturation: [],
  loadingSaturation: false,
  interval: undefined,
  selectedSaturation: undefined,
  selectedHeatSaturation: undefined,
  saturationRules: [],
  loadingSaturationRules: false,
  heatmap: undefined,
  loadingHeatmap: false,
  autoRefresh: { saturation: { active: false } }
};

const reducer: Reducer<SaturationState> = (
  state: SaturationState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case GET_SATURATION_RULES:
      return { ...state, ...action.payload };

    case GET_SATURATION:
      return { ...state, loadingSaturation: true };

    case SET_SATURATION:
      return {
        ...state,
        ...action.payload,
        loadingSaturation: false,
        lastUpdateSaturation: moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
      };

    case GET_SATURATION_ERROR:
      return { ...state, ...action.payload, loadingSaturation: false };

    case GET_HEATMAP_ERROR:
      return { ...state, ...action.payload, loadingHeatmap: false };

    case TOGGLE_SATURATION:
    case TOGGLE_SATURATION:
    case TOGGLE_SATURATION_AUTOREFRESH:
    case SET_SELECTED_SATURATION:
    case SET_SELECTED_HEATSATURATION:
    case GET_HEATMAP_DATA:
    case TOGGLE_HEATMAP:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
